import {DefaultRootState} from 'react-redux';

import {
  fetchUserJobDetails,
  markUserJobAsViewed,
  receiveUserJobDetail,
} from 'app/jobs/slice';
import store, {AppDispatchType} from 'app/store/AppStore';

import type {UserJobSerializedType} from 'sweet-types';

export const userJobDispatcher =
  (
    jobCreationPromise: Promise<{
      job: UserJobSerializedType;
    }>
  ) =>
  (
    dispatch: AppDispatchType,
    getState: () => DefaultRootState
  ): {
    job: Promise<UserJobSerializedType & {status: 'completed'}>;
    unsubscribe: () => void;
  } => {
    const subscription = {
      unsubscribed: false,
      unsubscribe: () => {
        subscription.unsubscribed = true;
      },
    };

    const jobPromise = new Promise<
      UserJobSerializedType & {status: 'completed'}
    >((resolve, reject) => {
      jobCreationPromise.then(
        ({job}) => {
          // save job details on the redux store
          dispatch(receiveUserJobDetail(job));

          if (subscription.unsubscribed) {
            return;
          }

          // asks for the job status each 5 seconds (just in case)
          const statusCheckIntervalId = setInterval(() => {
            dispatch(fetchUserJobDetails(job.url));
          }, 5000);

          // check if job status was changed when our redux is updated
          const storeUnsubscribe = store.subscribe(() => {
            const updatedJob = getState().userjobs.byId[
              job.id
            ] as UserJobSerializedType;

            if (updatedJob.status !== 'processing') {
              subscription.unsubscribe();

              // tell backend user knows the job is completed
              // so it won't show it to user on page-reload
              dispatch(markUserJobAsViewed(updatedJob.url));

              return updatedJob.status === 'completed'
                ? resolve(updatedJob)
                : reject(updatedJob);
            }
          });

          subscription.unsubscribe = () => {
            storeUnsubscribe();
            clearInterval(statusCheckIntervalId);
          };
        },
        (error) => reject(error)
      );
    });

    return {job: jobPromise, unsubscribe: () => subscription.unsubscribe()};
  };
